<template>
  <tr>
    <td>
      <EllipsisTip>{{ item.url }}</EllipsisTip>
    </td>
    <td>
      <div class="flex">
        <p>{{ item.date | dateText('YYYY.MM.DD') }}</p>
      </div>
    </td>
    <td>
      <Button
        :to="{
          name: 'seoResult',
          query: {
            date: $options.filters.dateText(item.date, 'YYYY-MM-DD'),
            id: item.id
          }
        }"
        size="w180"
        fsize="f14"
        icon="arrow_r"
        variant="main"
      >
        結果を見る
      </Button>
    </td>
    <td class="c-text--center">
      <Button variant="delete" :disabled="isDeleting" @click="deleteItem">
        削除
      </Button>
    </td>
  </tr>
</template>

<script>
import Button from '@/components/Button';
import EllipsisTip from '@/components/EllipsisTip';
import apiProjects from '@/api/projects';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Button,
    EllipsisTip
  },
  data() {
    return {
      errorResponse: '',
      isDeleting: false,
      isProcessing: false
    };
  },
  methods: {
    goDetail(data) {
      this.$router.push({
        name: 'seoResult',
        query: {
          date: this.$options.filters.dateText(data.date, 'YYYY-MM-DD'),
          id: data.id
        }
      });
    },
    deleteItem() {
      if (this.isDeleting) {
        return;
      }
      this.isDeleting = true;

      apiProjects.pageCheckups
        .delete(this.auth.idToken, this.project.id, this.item.id)
        .then(response => {
          this.$emit('delete', this.item);
        })
        .catch(error => {
          this.isDeleting = false;
        });
    }
  }
};
</script>
